module.exports = __webpack_public_path__ + "static/media/bru-r.8164b18b.mp3";